import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    Empty,
    Flex,
    Input,
    Spin,
    Space,
    message,
    Tag,
    Tooltip,
    Typography,
    Dropdown,
    Menu,
    Skeleton
} from "antd";
import {
    SearchOutlined,
    PlusOutlined,
    ReloadOutlined,
    EditOutlined,
    DeleteOutlined,
    DownOutlined,
    LeftOutlined,
    RightOutlined,
    InboxOutlined,
} from "@ant-design/icons";
import CreateDonation from "./CreateDonation";
import api from "../../../api";// adjust path according to your project
import RejectionModal from "../Approval/RejectionModal";
import { useNavigate } from "react-router-dom";


const { Title, Text } = Typography;

const Donation = () => {
    const [donationData, setDonationData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState("All");
    const [openCreateDonation, setOpenCreateDonation] = useState(false);
    const [editDonationData, setEditDonationData] = useState(null);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [selectedDonation, setSelectedDonation] = useState(null);
    const [expandedId, setExpandedId] = useState(null);

    const [pageSize, setPageSize] = useState(6);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();




    // 🔥 Fetch donations from API
    // 🔥 Fetch donations from API
    const fetchDonations = async () => {
        setLoading(true);
        try {
            const payload = {
                synceddatetime: "2025-05-29 10:08:00",
                FormCode: "201",
                AppVersion: "1.0.0.0",
                ApiKey: "kavin",
                AppTypeNo: "3",
            };

            const response = await api.getdonation(payload);
            if (response.status === 200 && response.data.services_products_data) {
                // Map API fields to the component fields
                const mappedData = response.data.services_products_data.map((item) => ({
                    id: item.fld_rf_id,
                    rf_id: item.fld_rf_id,
                    donation_id: item.fld_donation_id,

                    title: item.fld_donation_name,
                    description: item.fld_donation_description,
                    location: item.fld_location,
                    amount: item.fld_goal_ammount,

                    status: item.fld_is_active === "1" ? "Active" : "Closed",
                    image: item.fld_image_path || "https://via.placeholder.com/80",

                    // ✅ ADD THESE (IMPORTANT)
                    contact: item.fld_contact_no,
                    email: item.fld_email_id,
                    startDate: item.fld_start_date,
                    endDate: item.fld_end_date,

                    // ✅ keep full raw data (best practice)
                    raw: item,
                }));

                setDonationData(mappedData);
            } else {
                setDonationData([]);
            }
        } catch (error) {
            console.error("Error fetching donations:", error);
            setDonationData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDonations();
    }, []);

    // 🔍 Filters
    const filteredData = donationData
        .filter((item) => {
            const matchesSearch = item.title
                .toLowerCase()
                .includes(searchTerm.toLowerCase());

            const matchesStatus =
                statusFilter === "All" || item.status === statusFilter;

            return matchesSearch && matchesStatus;
        })
        .sort((a, b) => b.rf_id - a.rf_id); // 🔥 newest first

    // 📄 Pagination
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);
    const totalPages = Math.ceil(filteredData.length / pageSize);

    const pageMenu = (
        <Menu
            items={[6, 10, 20].map((num) => ({
                key: num,
                label: num,
                onClick: () => {
                    setPageSize(num);
                    setCurrentPage(1);
                },
            }))}
        />
    );

    const handleOpenCreate = () => {
        setEditDonationData(null);
        setOpenCreateDonation(true);
    };

    const handleEditDonation = (donation) => {
        setEditDonationData(donation);
        setOpenCreateDonation(true);
    };

    const handleCloseDonationModal = () => {
        setOpenCreateDonation(false);
        setEditDonationData(null);
        fetchDonations(); // refresh list after creating/editing
    };

    const handleDelete = (data) => {

        setSelectedDonation(data);
        setOpenDeleteModal(true);


    }

    const handleDeleteDonation = async () => {
        try {
            const payload = {
                "fld_rf_id": selectedDonation?.rf_id,
                "synceddatetime": "2025-05-29 10:08:00",
                "FormCode": "201",
                "AppVersion": "1.0.0.0",
                "ApiKey": "kavin",
                "AppTypeNo": "3"

            };

            const res = await api.deleteDonation(payload); // adjust API name

            if (res.data.status === '1') {
                messageApi.success("Donation deleted successfully");
            }

            setOpenDeleteModal(false);
            fetchDonations();
        } catch (err) {
            console.error(err);
            messageApi.success("Failed to delete donation ");
        }
    };


    const DonationSkeleton = () => (
        <Card bodyStyle={{ padding: "12px 16px" }}>
            <Flex justify="space-between" align="center">

                <Flex gap={12}>
                    <Skeleton.Image
                        active
                        style={{
                            width: 70,
                            height: 70,
                        }}
                    />

                    <div>
                        {/* Title + Status */}
                        <div
                            style={{
                                display: "flex",
                                gap: 8,
                                marginBottom: 6,
                            }}
                        >
                            <Skeleton.Input
                                active
                                size="small"
                                style={{
                                    width: 180,
                                }}
                            />

                            <Skeleton.Button
                                active
                                size="small"
                                style={{
                                    width: 60,
                                }}
                            />
                        </div>

                        {/* Description */}
                        <Skeleton.Input
                            active
                            size="small"
                            style={{
                                width: 320,
                                marginBottom: 6,
                            }}
                        />

                        <Skeleton.Input
                            active
                            size="small"
                            style={{
                                width: 220,
                                marginBottom: 6,
                            }}
                        />

                        {/* Location */}
                        <Skeleton.Input
                            active
                            size="small"
                            style={{
                                width: 140,
                                marginBottom: 6,
                            }}
                        />

                        {/* Amount */}
                        <Skeleton.Input
                            active
                            size="small"
                            style={{
                                width: 90,
                            }}
                        />
                    </div>
                </Flex>

                <Space>
                    <Skeleton.Button active size="small" />
                    <Skeleton.Button active size="small" />
                </Space>

            </Flex>
        </Card>
    );

    return (
        <>
            {openCreateDonation && (
                <CreateDonation
                    visible={openCreateDonation}
                    handleCancel={handleCloseDonationModal}
                    onCancel={() => setOpenCreateDonation(false)}
                    onSuccess={handleCloseDonationModal}
                    editdata={editDonationData}
                />
            )}



            <div className="review-page">
                {/* Header */}
                {contextHolder}
                <Flex className="review-header" justify="space-between" align="center" style={{ marginBottom: 16 }}>
                    <Input
                        className="review-search"
                        prefix={<SearchOutlined />}
                        placeholder="Search donations..."
                        style={{ width: 300 }}
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={handleOpenCreate}
                            style={{ background: "#0072b1" }}
                        >
                            Create Donation
                        </Button>
                    </Space>
                </Flex>

                {/* Title */}
                <div className="review-container">
                    <div className="review-heading">
                        <Title level={4} style={{ margin: 0 }}>
                            Donation Management
                        </Title>
                        <Text type="secondary">Manage and track donation campaigns</Text>
                    </div>

                    {/* Filters */}
                    <div className="review-filters">
                        <div className="filter-buttons">
                            <Dropdown
                                overlay={
                                    <Menu
                                        items={[
                                            { key: "All", label: "All", onClick: () => setStatusFilter("All") },
                                            { key: "Active", label: "Active", onClick: () => setStatusFilter("Active") },
                                            { key: "Closed", label: "Closed", onClick: () => setStatusFilter("Closed") },
                                        ]}
                                    />
                                }
                            >
                                <Button>
                                    {statusFilter} <DownOutlined />
                                </Button>
                            </Dropdown>

                            <Button
                                icon={<ReloadOutlined />}
                                onClick={() => {
                                    setStatusFilter("All");
                                    setSearchTerm("");
                                }}
                            >
                                Reset
                            </Button>
                        </div>
                    </div>

                    {/* Cards */}
                    <div style={{ display: "grid", gap: 16 }}>
                        {loading ? (
                            Array.from({ length: 6 }).map((_, index) => (
                                <DonationSkeleton key={index} />
                            ))
                        ) : paginatedData.length === 0 ? (
                            <Card>
                                <Empty
                                    description="No donations available"
                                    image={<InboxOutlined style={{ fontSize: 40 }} />}
                                />
                            </Card>
                        ) : (
                            paginatedData.map((donation) => (
                                <Card
                                    key={donation.id}
                                    hoverable
                                    className="review-card"
                                    onClick={() =>
                                        navigate(`donation/${donation.id}`, {
                                            state: { donationData: donation },
                                        })
                                    }
                                >
                                    <Flex justify="space-between" align="center">
                                        {/* Left */}
                                        <Flex gap={16}>
                                            <img
                                                src={donation.image}
                                                alt="donation"
                                                style={{
                                                    width: 80,
                                                    height: 80,
                                                    objectFit: "cover",
                                                    borderRadius: 8,
                                                }}
                                            />
                                            <div>
                                                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>

                                                    <Text strong>{donation.title}</Text>
                                                    <div>
                                                        <Tag

                                                            color={donation.status === "Active" ? "green" : "red"}

                                                        >
                                                            {donation.status}
                                                        </Tag>
                                                    </div>


                                                </div>

                                                <div style={{ color: "#888" }}>
                                                    <div
                                                        style={
                                                            expandedId === donation.id
                                                                ? {}
                                                                : {
                                                                    display: "-webkit-box",
                                                                    WebkitLineClamp: 2,
                                                                    WebkitBoxOrient: "vertical",
                                                                    overflow: "hidden",
                                                                }
                                                        }
                                                    >
                                                        {donation.description}
                                                    </div>

                                                    {donation.description?.length > 80 && (
                                                        <span
                                                            style={{
                                                                color: "#1677ff",
                                                                cursor: "pointer",
                                                                fontSize: 12,
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation(); // ✅ important (prevents card click)
                                                                setExpandedId(expandedId === donation.id ? null : donation.id);
                                                            }}
                                                        >
                                                            {expandedId === donation.id ? "Show less" : "Show more..."}
                                                        </span>
                                                    )}
                                                </div>
                                                <div style={{ marginTop: 4 }}>
                                                    <Text type="secondary">📍 {donation.location}</Text>
                                                </div>
                                                {donation.amount && Number(donation.amount) > 0 && (
                                                    <div>
                                                        <Text style={{ color: "#52c41a", fontWeight: 500 }}>
                                                            ₹ {donation.amount}
                                                        </Text>
                                                    </div>
                                                )}

                                            </div>
                                        </Flex>

                                        {/* Right */}
                                        <Space>
                                            <Tooltip title="Edit Donation">
                                                <Button
                                                    icon={<EditOutlined />}
                                                    size="small"
                                                    style={{
                                                        borderRadius: 6,
                                                        borderColor: "#ccc",
                                                        color: "#555",
                                                        background: "white",
                                                    }}
                                                    onClick={(e) => {

                                                        e.stopPropagation();
                                                        handleEditDonation(donation)
                                                    }}
                                                >
                                                    Edit
                                                </Button>
                                            </Tooltip>

                                            <Tooltip title="Delete Donation">
                                                <Button
                                                    icon={<DeleteOutlined />}
                                                    size="small"
                                                    style={{
                                                        borderRadius: 6,
                                                        borderColor: "#ccc",
                                                        color: "#d9534f",
                                                        background: "white",
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDelete(donation)

                                                    }}
                                                >
                                                    Delete
                                                </Button>
                                            </Tooltip>
                                        </Space>
                                    </Flex>
                                </Card>
                            ))
                        )}
                    </div>

                    {/* Pagination */}
                    <Flex justify="center" align="center" gap={10} style={{ marginTop: 20 }}>
                        <Button
                            icon={<LeftOutlined />}
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((p) => p - 1)}
                        />
                        <span>
                            Page {currentPage} of {totalPages || 1}
                        </span>
                        <Button
                            icon={<RightOutlined />}
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((p) => p + 1)}
                        />

                        <Dropdown overlay={pageMenu}>
                            <Button>
                                {pageSize} / page <DownOutlined />
                            </Button>
                        </Dropdown>
                    </Flex>
                </div>
            </div>


            {openDeleteModal && (
                <RejectionModal
                    title="Delete Donation"
                    content="Are you sure you want to delete this donation? This action cannot be undone."
                    buttonName="Delete"
                    open={openDeleteModal}
                    onClose={() => setOpenDeleteModal(false)}
                    onSubmit={handleDeleteDonation}
                />
            )}
        </>
    );
};

export default Donation;